export default __webpack_public_path__ + "static/bg_marbre-f159678273de0151e56044b8a2a84095.jpeg";